import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import { Typography } from '@material-ui/core';
import { ErrorSharp as ErrorIcon } from '@material-ui/icons';
import { DelaStarIcon } from '~/modules/common/components/Icons';
import useStyles from './useStyles';

export const ResourceMatchItemError = ({ dataQeId }) => {
  const classes = useStyles();
  const { formatMessage } = useIntl();
  const resourceMatchItemErrorDataQeId = dataQeId
    ? `${dataQeId}_ResourceMatchItemError`
    : undefined;

  return (
    <div
      data-qe-id={resourceMatchItemErrorDataQeId}
      className={classes.itemRoot}
    >
      <div className={classes.itemContainer}>
        <div className={classes.itemTextContainer}>
          <Typography variant="caption" color="textPrimary">
            {formatMessage({
              id: 'resourceMatchItem.resourceMatcher'
            })}
          </Typography>
          <DelaStarIcon className={classes.itemDelaStarIcon} />
        </div>
        <div
          className={classNames(
            classes.itemTextContainer,
            classes.itemNegativeMargin
          )}
        >
          <ErrorIcon className={classes.itemErrorIcon} color="error" />
          <Typography variant="body2" color="error">
            {formatMessage({
              id: 'resourceMatchItem.error'
            })}
          </Typography>
        </div>
      </div>
    </div>
  );
};

ResourceMatchItemError.propTypes = {
  dataQeId: PropTypes.string
};

export default ResourceMatchItemError;
